import { atom } from "jotai";

// 전역 상태 관리
export const storeOriginPlaceList = atom(new Array());
export const storePlaceList = atom(new Array());